import React, { Component } from 'react';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';
import Loader from 'halogen/PulseLoader';
import PropTypes from 'prop-types';
import messages from './messages';
import css from './index.scss';
import Button from '../button/index';
import PortalCommunication from '../../portal-comms';
import DropDownList from '../dropdown-list/index';
import listStyle from './dropdown-list.scss';

class ActivityAssignPreference extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defaultOption: {
                key: -1,
                value: this.props.intl.formatMessage(messages.option)
            },
            enableSave: !this.props.isSaveInProgress || this.validateInputs(),
            selectedStartDate: null,
            selectedDueDate: null,
            isInitialLoad: true,
            saveRequest: [
                {
                    type: 'activity-start-date',
                    value: '-1'
                },
                {
                    type: 'activity-due-date',
                    value: '-1'
                }
            ],
            resetRequest: {
                types: ['activity-start-date', 'activity-due-date']
            }
        };
    }

    componentWillReceiveProps(nextProps) {
        const { activityAssignPreferences } = nextProps;
        if (this.state.selectedStartDate === null && this.state.selectedDueDate === null) {
            const activityStartDate = activityAssignPreferences.find(a => a.type === 'activity-start-date');
            const activityDueDate = activityAssignPreferences.find(a => a.type === 'activity-due-date');
            this.setState({
                selectedStartDate: activityStartDate.preferredValue || '-1',
                selectedDueDate: activityDueDate.preferredValue || '-1'
            });
        }
    }

    renderDropdownLists = () => {
        const { activityAssignPreferences, intl } = this.props;
        const activityStartDate = activityAssignPreferences.find(a => a.type === 'activity-start-date');
        const activityDueDate = activityAssignPreferences.find(a => a.type === 'activity-due-date');
        const activityStartDateOptions = activityStartDate.availableOptions.map(item => ({
            key: item.value,
            value: item.text
        }));
        activityStartDateOptions.unshift(this.state.defaultOption);
        const activityDueDateOptions = activityDueDate.availableOptions.map(item => ({
            key: item.value,
            value: item.text
        }));
        activityDueDateOptions.sort((a, b) => a.key - b.key);
        activityDueDateOptions.unshift(this.state.defaultOption);
        return (<div className={css.notificationPanel}>
            <div className={css.due}>
                <div className={css.dueLabel}>{intl.formatMessage(messages.due)}</div>
                <div className={css.dueList}>
                    <DropDownList
                        css={listStyle}
                        name="activity-start-date"
                        onChange={this.onDropDownChange}
                        options={activityStartDateOptions}
                        value={this.state.selectedStartDate}
                    />
                </div>
            </div>
            <div className={css.notification}>
                <div className={css.notificationLabel}>{intl.formatMessage(messages.notification)}</div>
                <div className={css.notificationList}>
                    <DropDownList
                        css={listStyle}
                        name="activity-due-date"
                        onChange={this.onDropDownChange}
                        options={activityDueDateOptions}
                        value={this.state.selectedDueDate}
                    />
                </div>
            </div>
        </div>);
    }

    savePreference = () => {
        const request = {
            preferences: this.state.saveRequest.filter(r => r.value !== '-1')
        };
        this.props.saveActivityAssignPreferences(request);
    }

    validateInputs = () => {
        const { selectedStartDate, selectedDueDate, isInitialLoad } = this.state;
        const { isSaveInProgress } = this.props;
        if (!isInitialLoad) {
            if (selectedStartDate !== '-1' || selectedDueDate !== '-1') {
                if (isSaveInProgress) {
                    return true;
                }
                return false;
            }
        }
        return true;
    }

    enableReset = () => {
        const { selectedStartDate, selectedDueDate, isInitialLoad } = this.state;
        if (isInitialLoad && (selectedStartDate !== '-1' || selectedDueDate !== '-1')) {
            return false;
        } else if (selectedStartDate !== '-1' || selectedDueDate !== '-1') {
            return false;
        }

        return true;
    }

    onDropDownChange = (field, value) => {
        const clonedSaveRequest = cloneDeep(this.state.saveRequest);
        clonedSaveRequest.find(a => a.type === field).value = value;
        if (field === 'activity-start-date') {
            this.setState({
                saveRequest: clonedSaveRequest,
                selectedStartDate: value,
                isInitialLoad: false
            });
        } else {
            this.setState({
                saveRequest: clonedSaveRequest,
                selectedDueDate: value,
                isInitialLoad: false
            });
        }
    }

    resetPreferences = () => {
        const { activityAssignPreferences } = this.props;
        this.props.resetPreference({ types: activityAssignPreferences.map(item => (item.type)) });
    }

    render() {
        const { intl, isDataLoaded, isSaveInProgress } = this.props;
        return (<div>
            <div className={css.header}>
                <div className={css.title}>{intl.formatMessage(messages.pageTitle)}</div>
            </div>
            <div className={css.selectionPanel}>
                <div className={css.display}>{intl.formatMessage(messages.pageSubHeading)}</div>
                {
                    !isDataLoaded ? (<div className={css.loaderContainer}>
                        <Loader className={css.loader} />
                    </div>) : (<div>
                        {this.renderDropdownLists()}</div>)
                }
            </div>
            <div className={css.settingsFooter}>
                <Button
                    containerClassName={css.cancelButton}
                    handleOnClick={() => {
                        PortalCommunication.navigateToLandingScreen('Settings');
                    }}
                    label={intl.formatMessage(messages.cancel)}
                />
                <Button
                    containerClassName={css.cancelButton}
                    disabled={isSaveInProgress || this.enableReset()}
                    handleOnClick={this.resetPreferences}
                    label={intl.formatMessage(messages.reset)}
                />
                <Button
                    containerClassName={css.saveButton}
                    disabled={this.validateInputs()}
                    handleOnClick={this.savePreference}
                    label={intl.formatMessage(messages.save)}
                />
            </div>
        </div>);
    }
}

ActivityAssignPreference.propTypes = {
    intl: intlShape.isRequired,
    activityAssignPreferences: PropTypes.array,
    isSaveInProgress: PropTypes.bool,
    isDataLoaded: PropTypes.bool,
    saveActivityAssignPreferences: PropTypes.func,
    resetPreference: PropTypes.func
};

export default injectIntl(styleable(css)(ActivityAssignPreference));



// WEBPACK FOOTER //
// ./app/components/activity-assign-preference/index.js